import SpriteSymbol from "../../../../dev-d21-front/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../dev-d21-front/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bot-anlyzer",
  "use": "bot-anlyzer-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 15 14\" id=\"bot-anlyzer\"><path fill=\"currentColor\" d=\"M2.1 7.6h10.8a.6.6 0 0 0 0-1.2H2.1a.6.6 0 0 0 0 1.2m0-3.6h10.8a.6.6 0 0 0 0-1.2H2.1a.6.6 0 0 0 0 1.2m0 7.2h10.8a.6.6 0 0 0 0-1.2H2.1a.6.6 0 1 0 0 1.2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol